import { selectOrgID } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useOrgID = () => useSelector(selectOrgID);

export default useOrgID;
